import { useState } from "react";
import { FiX, FiSlash, FiMessageCircle } from "react-icons/fi";
import toast from "react-hot-toast";
import useChatStore from "../../store/chatStore";
import useAuthStore from "../../store/authStore";
import { getInitials, formatLastSeen } from "../../utils/helpers";
import BlockConfirmModal from "./BlockConfirmModal";
import styles from "./UserInfoPanel.module.css";

const UserInfoPanel = ({ other, onClose }) => {
  const { onlineUsers, blockUser } = useChatStore();
  const { user } = useAuthStore();
  const [showBlockConfirm, setShowBlockConfirm] = useState(false);

  const isOnline = onlineUsers.includes(other?._id);

  const handleBlockConfirm = async () => {
    setShowBlockConfirm(false);
    try {
      await blockUser(other._id);
      toast.success(`${other.name} blocked`);
      onClose();
    } catch { toast.error("Failed to block user"); }
  };

  if (!other) return null;

  return (
    <div className={styles.panel}>
      {/* Header */}
      <div className={styles.header}>
        <span className={styles.headerTitle}>Contact info</span>
        <button className={styles.closeBtn} onClick={onClose}><FiX size={18} /></button>
      </div>

      {/* Hero */}
      <div className={styles.heroSection}>
        <div className={styles.avatarWrap}>
          <div className={styles.avatar}>
            {other.avatar
              ? <img src={other.avatar} alt={other.name} className={styles.avatarImg} />
              : <span className={styles.avatarInitials}>{getInitials(other.name)}</span>}
          </div>
          <span className={`${styles.statusDot} ${isOnline ? styles.dotOnline : styles.dotOffline}`} />
        </div>
        <h2 className={styles.name}>{other.name}</h2>
        <span className={`${styles.statusText} ${isOnline ? styles.statusOnline : styles.statusOffline}`}>
          {isOnline ? "● Online" : other.lastSeen ? `Last seen ${formatLastSeen(other.lastSeen)}` : "Offline"}
        </span>
      </div>

      {/* Bio */}
      {other.bio && (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>About</div>
          <p className={styles.bioText}>{other.bio}</p>
        </div>
      )}

      {/* Email */}
      {other.email && (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>Email</div>
          <p className={styles.infoText}>{other.email}</p>
        </div>
      )}

      {/* Actions */}
      <div className={styles.actions}>
        <button className={styles.blockBtn} onClick={() => setShowBlockConfirm(true)}>
          <FiSlash size={16} />
          <span>Block {other.name}</span>
        </button>
      </div>

      {showBlockConfirm && (
        <BlockConfirmModal
          userName={other.name}
          onConfirm={handleBlockConfirm}
          onCancel={() => setShowBlockConfirm(false)}
        />
      )}
    </div>
  );
};

export default UserInfoPanel;
